import React, { useEffect, useState } from "react"
import compose from "recompose/compose"
import styled from "styled-components"
import { t } from "@/i18n"
import { withi18n } from "@/helpers/hoc/withi18n"
import { Box } from "@xingternal/winery-ui/lib/Box"
import { Label } from "@xingternal/winery-ui/lib/Label"
import { Sidebar } from "@xingternal/winery-ui/lib/Sidebar"
import { OTMAdminSidebarItems } from "../OTMAdminSidebarItems"
import { SidebarHeaderLayout } from "../SidebarHeaderLayout"
import { otmNavItems, otpNavItems } from "./constants"
import { isAdmin } from "@/helpers/authorization"
import hasXTM from "@/helpers/authorization/hasXTM"
import { hasXTP } from "@/helpers/authorization/hasXTP"
import { onlyfyFullTheme } from "@xingternal/rebranding-adapter"
import { getTotalUnreadMessages } from "@/services/api"

const i18n = {
  talentManagerHeader:
    "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_HEADER_TALENT_MANAGER",
  talentPoolManagerHeader:
    "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_HEADER_TALENT_POOL_MANAGER",
  hotleadsNewLabel: "360_RECRUITER_INSIGHTS_LABEL_NEW",
}

const HotleadsNewLabel = styled(Label).attrs({
  type: "eyeCatcher",
})`
  flex-shrink: 0;
  margin-left: 8px;
`

const shouldShowOtmNavItem = (item, permissions) =>
  item.id !== "hotleads" || hasXTM({ permissions })

const OTMSidebarItems = ({ isCollapsed, permissions }) => {
  const [totalUnreadMessages, setTotalUnreadMessages] = useState(null)

  useEffect(() => {
    (async function () {
      try {
        const { data } = await getTotalUnreadMessages()
        setTotalUnreadMessages(data?.viewer?.chats?.total || null)
      } catch (error) {
        console && console.log(error)
      }
    })()
  }, [])

  return (
    <>
      <SidebarHeaderLayout
        backgroundColor={onlyfyFullTheme.colors.xtm}
        isCollapsed={isCollapsed}
        icon="Insights"
      >
        {t(i18n.talentManagerHeader)}
      </SidebarHeaderLayout>
      {otmNavItems
        .filter((item) => shouldShowOtmNavItem(item, permissions))
        .map((item) => (
          <Box key={item.id}>
            <Sidebar.Item
              isActive={false}
              icon={item.icon}
              href={item.href}
              count={item.id === "messages" ? totalUnreadMessages : null}
              data-testid={`sidebar-item-${item.id}`}
            >
              {t(item.label)}
              {item.id === "hotleads" && (
                <HotleadsNewLabel data-testid="sidebar-item-hotleads-new-label">
                  {t(i18n.hotleadsNewLabel)}
                </HotleadsNewLabel>
              )}
            </Sidebar.Item>
          </Box>
        ))}

      {isAdmin(permissions) && (
        <OTMAdminSidebarItems
          isCollapsed={isCollapsed}
          permissions={permissions}
        />
      )}

      {hasXTP({ permissions }) && (
        <>
          <SidebarHeaderLayout
            backgroundColor={onlyfyFullTheme.colors.xtp}
            isCollapsed={isCollapsed}
            icon="Insights"
          >
            {t(i18n.talentPoolManagerHeader)}
          </SidebarHeaderLayout>
          {otpNavItems.map((item) => (
            <Box key={item.id}>
              <Sidebar.Item isActive={false} icon={item.icon} href={item.href}>
                {t(item.label)}
              </Sidebar.Item>
            </Box>
          ))}
        </>
      )}
    </>
  )
}

const enhance = compose(withi18n(i18n))

export default enhance(OTMSidebarItems)
